import React, { useEffect, useContext, useState } from 'react';
import { Card, CardContent, Typography, Button, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import BreadcrumbsWrapper from '../../../components/breadcrumbs' 
//import { Helmet } from 'react-helmet-async';

export const  ViewUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [singleUser, setSingleUser] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await postRequest(`private/viewUser/${id}`, {}, authCtx.token);
        console.log(response, 'response');
        console.log('User Data:', response?.data);
        console.log('Partner ID:', response?.data?.partner_id);
        if (response?.status === 200) {
          setSingleUser(response?.data);
        }
      } catch (err) {
        console.error('Error fetching solicitor:', err);
      }
    };

    fetchUserData();
  }, [id, authCtx.token]);

  return (
    <>

        {/* <Helmet>
                <title>View User - Universal Admin</title>
              </Helmet>
              <h1>View User</h1> */}

<div className="page-header pb-3">
        <h1 className="mt-0 mb-0"> {singleUser ? (
          <>
            {singleUser?.forename} <span style={{ fontWeight: 300 }}>{singleUser?.surname}</span>
          </>
        ) : (
          'Loading...'
        )}</h1>
      </div>


                  <BreadcrumbsWrapper
                                      items={[
                                        { label: 'Dashboard', path: '/dashboard' },
                                        { label: 'Users', path: '/users' },
                                        { label: 'View user', path: '' },
                                      ]}
                                    />
                              <br></br>

    <div style={{ padding: '20px' }}>
      {/* <Typography variant="h4" gutterBottom>
       
      </Typography> */}

      <Stack direction="row" spacing={2} marginBottom={2}>
        <Button
          variant="outlined"
          sx={{
            color: '#bb0000',
            borderColor: '#bb0000',
            '&:hover': {
              borderColor: '#bb0000',
              backgroundColor: 'rgba(187, 0, 0, 0.04)',
            },
          }}
          onClick={()=>navigate(`/reset-password/${id}`,{state:{key:'user'}})}
        >
          Reset Password
        </Button>
      </Stack>

      <Card variant="outlined">
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="body1">
              <strong>Username:</strong> {singleUser?.username || '-'}
            </Typography>
            <Typography variant="body1">
              <strong>Email:</strong> {singleUser?.email || '-'}
            </Typography>
            <Typography variant="body1">
              <strong>Phone:</strong> {singleUser?.phone_number || '-'}
            </Typography>
            <Typography variant="body1">
              <strong>Partner:</strong> {singleUser?.partner_id?.name || 'No partner assigned'}
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </div>
    </>
  );
};

